import LoginCard from './loginCard'

export default LoginCard